module.exports = __webpack_public_path__ + "img/rubin-img-07.596c202d.jpg";